import { Injector } from '@angular/core';
import { environment } from '@env/environment';
import HelpCrunchWidgetService from './help-crunch-widget.service';

export default function helpCrunchWidgetFactory(
  injector: Injector,
): () => void {
  return () => {
    if (environment.production && environment.helpCrunchWidgetSettings) {
      injector.get(HelpCrunchWidgetService);
    }
  };
}
